import {
    createRouter,
    createWebHistory,
    Router, RouterOptions,
} from 'vue-router';
import {sync} from 'vuex-router-sync';
import store from '@/store';
import {routes} from './routes';

const options: RouterOptions = <RouterOptions>{
    history: createWebHistory(process.env.BASE_URL),
    routes: routes,
};

const router: Router = createRouter(options);

sync(store, router);

export default router;
